<template>
  <el-dialog ref="depentConfig" title="配置从属字段" size="small">
    <el-table
      :data="keyDepent"
      style="width: 100%">
      <el-table-column
        label="从属字段">
        <template scope="scope">
          <el-select v-model="scope.row.name" placeholder="从属字段" class="w-150 m-r-10">
            <el-option v-for="option in showName" :label="option" :value="option"></el-option>
          </el-select>
        </template>  
      </el-table-column>
      <el-table-column
        label="字段标题">
        <template scope="scope">
          <el-input v-model="scope.row.title" placeholder="字段标题" class="w-150 m-r-10"></el-input>
        </template>  
      </el-table-column>
      <el-table-column
        label="操作">
        <template scope="scope">
          <el-button size="small" type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>  
      </el-table-column>
    </el-table>
    <div class="tx-c m-t-10">
      <el-button type="primary" @click="addRow">添加一行</el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDepentConfig">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  /**
   * @param Array keyDepent 从属字段
   * @param Array showName 显示名数组
   */
  export default {
    props: {
      keyDepent: {
        type: Array,
        default() {
          return []
        }
      },
      showName: {
        type: Array,
        default() {
          return []
        }
      }
    },
    name: 'depentConfig',
    data() {
      return {
        depentModel: {
          name: '',
          title: ''
        }
      }
    },
    methods: {
      openDialog() {
        this.$refs.depentConfig.open()
      },
      closeDialog() {
        this.$refs.depentConfig.close()
      },
      addRow() {
        this.keyDepent.push(_.cloneDeep(this.depentModel))
      },
      deleteRow(index) {
        this.keyDepent.splice(index, 1)
      },
      confirmDepentConfig() {
        this.$emit('confirmDepentConfig', this.keyDepent)
        this.closeDialog()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// depentConfig.vue?fcabfa76